<template>
  <div class="relative flex flex-col justify-center items-center -ml-100 w-7/12 rounded-2xl bg-white py-6">
    <span @click="closeModal" class="absolute left-8 top-4 text-customGray text-sm cursor-pointer">Close</span>
    <WarningIcon class="mb-2"/>
    <h2 class="text-center font-semibold mb-2 text-yank">Are you sure you want to remove this account?</h2>
    <form class="flex flex-col md:flex-row px-5" @submit.prevent="submit" >
        <button @click="closeModal" class="w-12/12 px-3 py-2 text-sm border-payneHot border-2 rounded-lg mr-2 mb-2 md:mb-0" type="button">No, I want to keep it active</button>
        <button class="w-12/12 px-10 py-2 text-sm bg-payneHot rounded-lg text-white" type="submit">Yes, I want to delete</button> 
    </form>
</div>
</template>

<script>
import WarningIcon from '@/components/svg/WarningIcon.vue';
export default {
    name:"ConfirmRemovalModal",

    components:{
        WarningIcon
    },

    props: {
        account: {
            type: Object,
            required:true,
        },
    },
    
    methods: {
        closeModal() {
            this.$emit('closeModal')
        },
        submit(){
            this.removeModalOpen = false
            this.$inertia.delete(this.$route('social-pages.destroy', { pageId: this.account.id }));
            FB.logout(function(response) {
                console.log('You are now logged out from facebook');
            });
            this.closeModal()
        }
    },
}
</script>